// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogUsePrepaidUsageRules_dialogContact_2dzMK"};